export const COLOR_OPTION_KEYWORDS = ['color', 'colour'];
